
module.config(function($stateProvider) {
    $stateProvider.state('student.enrollment', {
        url: '/enrollment',
        templateUrl: 'students/enrollment/view',
        controller: 'StudentEnrollmentController',
        resolve: {
            participant: function(ModelService, student) {
                return ModelService.get('participant', student.id)
            },
            enrollment: function(ModelService, student) {
                return ModelService.get('enrollment', student.id)
            },
            durations: function(ModelService, student, permissions) {
                if (permissions.viewDurationsOfStay) {
                    return ModelService.getRelation('enrollment', student.id,
                                                    'durations');
                } else {
                    return [];
                }
            },
        },
    });
});
